import { render, staticRenderFns } from "./EnrolmentResponseProgram.vue?vue&type=template&id=68f05144&scoped=true"
import script from "./EnrolmentResponseProgram.vue?vue&type=script&lang=js"
export * from "./EnrolmentResponseProgram.vue?vue&type=script&lang=js"
import style0 from "./EnrolmentResponseProgram.vue?vue&type=style&index=0&id=68f05144&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f05144",
  null
  
)

export default component.exports